module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/~/babel-runtime/core-js/object/assign.js
// module id = ../../../../babel-runtime/core-js/object/assign.js
// module chunks = 7